import React, { useContext } from "react";
import styled from "styled-components";
import LoginForm from "../modules/authentication/LoginForm";
import { Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import Modal from "./Modal";
import ButtonRound from "./ButtonRound";
import { AiOutlineLogin } from "react-icons/ai";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20%;
  padding-bottom: 10rem;
  justify-content: center;
  height: 100%; // This takes the full height of the viewport
  text-align: center;
`;

const Image = styled.img`
  width: 70rem;
  height: auto;
  margin-bottom: 1rem; // Space between image and text
`;

const TextBox = styled.div`
  font-size: 2.4em;
  color: var(--color-grey-800); // Example color
`;

function ProtectedRoute() {
  const { userDetails } = useContext(UserContext);
  const isAuth = Boolean(userDetails.userEmail);
  const location = useLocation();

  //userDetails && console.log("UserDetails Protected Route", userDetails);

  if (!isAuth) {
    return (
      <Container>
        <Image src="/images/NotAuthorized1.png" alt="Not Authorized" />
        <TextBox>USER LOGIN REQUIRED</TextBox>
        <Modal>
          <Modal.Open opens="login">
            <ButtonRound>
              <AiOutlineLogin />
            </ButtonRound>
          </Modal.Open>
          <Modal.Window name="login">
            <LoginForm redirectPath={location.pathname} />
          </Modal.Window>
        </Modal>
      </Container>
    );
  }

  return <Outlet />;
}

export default ProtectedRoute;
